module.exports = __webpack_public_path__ + "static/media/spaced-rep.c6ad113b.png";